/**
 * 工作流模块翻译 - 中文
 * 包含：待办、已完成、已发起、流程定义
 */
export default {
  workflow: {
    // 待办任务
    todo: {
      title: '待办任务',
      keyword: '关键词',
      keywordPlaceholder: '请输入业务标题/任务名称',
      taskName: '任务名称',
      businessTitle: '业务标题',
      businessType: '业务类型',
      taskStatus: '状态',
      receiveTime: '接收时间',
      approval: '审批',
      transfer: '转办',
      // 业务类型映射（已由 wf_business_type 字典表驱动，以下仅作 fallback）
      businessTypeContract: '合同',
      businessTypeContractNew: '合同新签',
      businessTypeContractRenewal: '合同续签',
      businessTypeContractAmendment: '合同变更',
      businessTypeMerchant: '招商',
      businessTypeOther: '其他',
      // 状态映射
      statusPending: '待处理',
      statusClaimed: '已签收',
    },
    // 已完成
    done: {
      title: '已完成',
      keyword: '关键词',
      keywordPlaceholder: '请输入业务标题/任务名称',
      taskName: '任务名称',
      businessTitle: '业务标题',
      businessType: '业务类型',
      action: '审批动作',
      comment: '审批意见',
      completeTime: '完成时间',
      // 审批动作映射
      actionApprove: '通过',
      actionReject: '驳回',
      actionTransfer: '转办',
      actionDelegate: '委托',
      // 业务类型映射（已由 wf_business_type 字典表驱动，以下仅作 fallback）
      businessTypeContract: '合同',
      businessTypeContractNew: '合同新签',
      businessTypeContractRenewal: '合同续签',
      businessTypeContractAmendment: '合同变更',
      businessTypeMerchant: '商户',
      businessTypeOther: '其他',
    },
    // 已发起
    initiated: {
      title: '已发起',
      processStatus: '流程状态',
      processStatusPlaceholder: '请选择流程状态',
      keyword: '关键词',
      keywordPlaceholder: '请输入业务标题/流程名称',
      processName: '流程名称',
      businessTitle: '业务标题',
      currentNode: '当前节点',
      instanceStatus: '流程状态',
      startTime: '发起时间',
      endTime: '结束时间',
      progress: '进度',
      withdraw: '撤回',
      withdrawConfirmTitle: '撤回确认',
      withdrawReasonPlaceholder: '请输入撤回原因（可选）',
      withdrawSuccess: '撤回成功',
      withdrawFailed: '撤回失败',
      getApprovalRecordsFailed: '获取审批记录失败',
      progressDialogTitle: '流程进度',
      noBusinessUrl: '暂无对应的业务详情页',
      // 流程状态映射
      statusAll: '全部',
      statusRunning: '进行中',
      statusCompleted: '已完成',
      statusRejected: '已驳回',
      statusCancelled: '已取消',
      statusSuspended: '已挂起',
    },
    // 流程定义
    definition: {
      title: '流程定义',
      processName: '流程名称',
      processNamePlaceholder: '请输入流程名称/标识',
      businessType: '业务类型',
      businessTypePlaceholder: '请选择业务类型',
      processKey: '流程标识',
      processKeyPlaceholder: '请输入流程标识（英文字母开头）',
      processKeyRule: '流程标识只能包含字母、数字、下划线和短横线，且必须以字母开头',
      processVersion: '版本',
      deployStatus: '发布状态',
      category: '流程分类',
      categoryPlaceholder: '请输入流程分类',
      processDescription: '流程描述',
      processDescriptionPlaceholder: '请输入流程描述',
      remarkPlaceholder: '请输入备注',
      // 状态
      enabled: '已启用',
      notEnabled: '未启用',
      deployed: '已发布',
      notDeployed: '未发布',
      // 操作
      design: '设计',
      deploy: '发布',
      // 对话框标题
      addTitle: '新增流程定义',
      editTitle: '编辑流程定义',
      designerTitle: '流程设计',
      saveProcess: '保存流程',
      // 确认消息
      deleteConfirm: '确定要删除该流程定义吗？',
      deleteConfirmTitle: '删除确认',
      deployConfirm: '确定要发布该流程定义吗？发布后将无法修改流程结构。',
      deployConfirmTitle: '发布确认',
      undeploy: '取消发布',
      undeployConfirm: '确定要取消发布该流程吗？取消后将变为草稿状态，可以修改流程结构。',
      undeployConfirmTitle: '取消发布确认',
      statusChangeConfirmTitle: '状态变更确认',
      statusChangeConfirm: '确定要{action}该流程定义吗？',
      // 成功/失败消息
      updateSuccess: '更新成功',
      createSuccess: '创建成功',
      deleteSuccess: '删除成功',
      deploySuccess: '发布成功',
      undeploySuccess: '取消发布成功',
      processSaveSuccess: '流程保存成功',
      saveFailed: '保存失败',
      deleteFailed: '删除失败',
      deployFailed: '发布失败',
      undeployFailed: '取消发布失败',
      getDetailFailed: '获取流程定义详情失败',
      enableSuccess: '启用成功',
      disableSuccess: '停用成功',
      enableFailed: '启用失败',
      disableFailed: '停用失败',
      // 业务类型（已由 wf_business_type 字典表驱动，以下仅作 fallback）
      businessTypeContract: '合同',
      businessTypeContractNew: '合同新签',
      businessTypeContractRenewal: '合同续签',
      businessTypeContractAmendment: '合同变更',
      businessTypeMerchant: '招商',
      businessTypeOther: '其他',
      // 内页
      backToList: '返回列表',
      readonlyDeployed: '已发布，只读',
      processDesign: '流程设计',
      notificationConfig: '通知配置',
      enableNotification: '启用流程通知',
      notifyCreator: '通知申请人',
      notifyCreatorTip: '审批完成后通知流程发起人',
      notifyPrevApprover: '通知上一步审批人',
      notifyPrevApproverTip: '审批完成后通知上一步审批人',
      notifyRoles: '通知角色',
      notifyRolesPlaceholder: '选择需要通知的角色',
      notifyRolesTip: '审批完成后通知这些角色的用户',
      commentRequired: '驳回必须填写原因',
      commentRequiredTip: '驳回时强制要求填写审批意见',
      notificationSaveSuccess: '通知配置保存成功',
      notificationSaveFailed: '通知配置保存失败',
      // 必填校验
      processKeyRequired: '请输入流程标识',
      processNameRequired: '请输入流程名称',
    },
  },
}
